export const downloadFile = (url: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_self';
  a.rel = 'noreferrer';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
};

